import React from 'react'
import _ from 'lodash'

export default function DisplayInputTextAttribute({
  stationData,
  attributeData,
}) {
  return attributeData?.inputText
}
